export const documentTypes = [
  { label: 'Daily SOAP Note', value: 'DAILY_SOAP_NOTE' },
  { label: 'Discharge', value: 'DISCHARGE' },
  { label: 'Evaluation', value: 'EVALUATION' },
  { label: 'Progress Note', value: 'WEEKLY_PROGRESS_NOTE' },
  { label: 'Recertification', value: 'RECERTIFICATION' },
];


export const documentTypesForPhysician = [
  { label: 'Evaluation', value: 'EVALUATION' },
  { label: 'Evaluation Reform', value: 'EVALUATION_REFORM' },
  { label: 'Recertification', value: 'RECERTIFICATION' },
];
export const physicianStatus = [
  { label: 'Awaiting Signature ', value: 'AWAITING_SIGNATURE' },
  { label: 'Upcoming', value: 'UPCOMING' },
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Overdue', value: 'OVERDUE' },
];
export const DisciplineType = [
  { label: 'PT', value: 'PT' },
  { label: 'OT', value: 'OT' },
  { label: 'SLP', value: 'SLP' },
];

export const docStatusTypes = [
  { label: 'Due Today', value: 'TODAY' },
  { label: 'Overdue', value: 'OVERDUE' },
  { label: 'Upcoming Deadline', value: 'UPCOMING' },
];

export const csvHeaders = [
  'Patient',
  'Document Type',
  'Discipline',
  'Therapist',
  'Due Date',
  'Status',
  'Action',
];

const getDocumentStatus = (document: any) => {
  if (!document?.submissionId) {
    return 'Complete document';
  } else if (document?.forSign) {
    return 'Sign document';
  } else if (document?.supervisorStatus === 'PENDING' && document?.supervisorId === null) {
    if (
      document?.formType?.includes('EVALUATION') ||
      document?.formType?.includes('RECERTIFICATION')
    ) {
      return 'Select Physician';
    } else {
      return 'Select Supervisor';
    }
  }
  if (
    document?.supervisorId !== null &&
    document?.supervisorStatus === 'PENDING' &&
    (document?.formType?.includes('EVALUATION') || document?.formType?.includes('RECERTIFICATION'))
  ) {
    return 'Physician signature pending';
  }
  if (
    document?.supervisorId !== null &&
    document?.supervisorStatus === 'PENDING' &&
    (!document?.formType?.includes('EVALUATION') ||
      !document?.formType?.includes('RECERTIFICATION'))
  ) {
    return 'Supervisor signature pending';
  } else {
    return '-';
  }
};

function replaceCommasWithSpace(str: any) {
  return str?.replace(/,/g, ' ');
}

export const convertToCSV = (data: any) => {
  const csvRows = [];
  csvRows?.push(csvHeaders?.join(','));
  data?.forEach((item: any) => {
    const document = {
      submissionId: item?.submissionId,
      forSign: item?.forSign,
      supervisorStatus: item?.supervisorStatus,
      supervisorId: item?.supervisorId,
      formType: item?.formType,
    };
    const row = [
      replaceCommasWithSpace(item?.patientName),
      item?.documentType,
      item?.type,
      replaceCommasWithSpace(item?.supervisorName),
      item?.dueDate,
      item?.status,
      getDocumentStatus(document),
    ];
    csvRows?.push(row?.join(','));
  });

  return csvRows?.join('\n');
};
